export default __webpack_public_path__ + "static/media/undraw_heavy_box_agqi.dfdc526b.svg";